import { formatDateTime } from '@formosa/shared/utils/formatDateTime';
import { resolveAdminMediaUrl } from '@formosa/shared/utils/mediaUrl';
import {
  depositStatusClassName,
  formatAmount,
  formatDepositStatus,
  formatDepositType,
  formatOptionalId,
  formatPhoneEmail,
  resolveDepositCurrencyAmount,
  resolveDepositExchangeRate,
  resolveDepositRealAmount,
  shouldShowDepositAuditTime,
} from './depositConstants';

function DetailRow({ label, value, className = '' }) {
  return (
    <div className="product-detail-row">
      <span className="product-detail-row__label">{label}</span>
      <span className={`product-detail-row__value ${className}`.trim()}>{value ?? '—'}</span>
    </div>
  );
}

export default function DepositDetailModal({ open, row, onClose }) {
  if (!open || !row) {
    return null;
  }

  const statusCode = typeof row.status === 'string' ? row.status : row.status?.name;
  const currencyAmount = resolveDepositCurrencyAmount(row);
  const exchangeRate = resolveDepositExchangeRate(row);
  const realAmount = resolveDepositRealAmount(row);

  return (
    <div className="admin-modal-overlay" role="presentation" onClick={onClose}>
      <div
        className="admin-modal admin-modal--wide"
        role="dialog"
        aria-modal="true"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="admin-modal__header">
          <h3>
            詳情 [{formatPhoneEmail(row.phoneEmail) || formatOptionalId(row.memberId)}]
          </h3>
          <button type="button" className="admin-modal__close" onClick={onClose}>
            ×
          </button>
        </div>
        <div className="admin-modal__body">
          <div className="product-detail-grid">
            <DetailRow label="用戶ID" value={formatOptionalId(row.memberId)} />
            <DetailRow label="用戶帳號" value={formatPhoneEmail(row.phoneEmail)} />
            <DetailRow label="數字貨幣" value={row.currencyName} />
            <DetailRow label="充值方式" value={formatDepositType(row.type)} />
            <DetailRow label="充值單號" value={formatOptionalId(row.id)} />
            <DetailRow
              label="狀態"
              value={formatDepositStatus(statusCode)}
              className={depositStatusClassName(statusCode)}
            />
            <DetailRow label="充幣數量" value={formatAmount(currencyAmount)} />
            <DetailRow label="實際到帳數量(USDT)" value={formatAmount(realAmount)} />
            <DetailRow label="充值時與USD的匯率" value={formatAmount(exchangeRate)} />
            <DetailRow
              label="審核時間"
              value={shouldShowDepositAuditTime(row) ? formatDateTime(row.updateTime) : '—'}
            />
            <DetailRow label="部門id" value={formatOptionalId(row.departmentId)} />
            <DetailRow label="後台處理人" value={formatOptionalId(row.adminId)} />
            <DetailRow label="備註" value={row.remark} />
            <div className="product-detail-row product-detail-periods">
              <span className="product-detail-row__label">交易憑證照片</span>
              <span className="product-detail-row__value">
                {row.receiptPhoto ? (
                  <a href={resolveAdminMediaUrl(row.receiptPhoto)} target="_blank" rel="noreferrer">
                    <img
                      src={resolveAdminMediaUrl(row.receiptPhoto)}
                      alt="交易憑證"
                      className="deposit-detail-receipt"
                    />
                  </a>
                ) : (
                  '—'
                )}
              </span>
            </div>
          </div>
        </div>
        <div className="admin-modal__footer admin-modal__footer--center">
          <button type="button" className="btn btn-danger" onClick={onClose}>
            關閉
          </button>
        </div>
      </div>
    </div>
  );
}
